// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--22807";
export var headingContainer = "index-module--heading-container--0bf3c";
export var highlight = "index-module--highlight--6cdd3";
export var highlightLine = "index-module--highlight-line--cdb8f";
export var image1 = "index-module--image-1--3735a";
export var image2 = "index-module--image-2--03474";
export var imageContainer = "index-module--image-container--b6b02";